// functions/src/billingoConstants.ts

/**
 * This file defines constants and types related to the Billingo API v3.
 * Populate these with values found in the official Billingo documentation,
 * the Billingo web interface, or through API testing.
 */

// --- Document Types ---
export const BILLINGO_DOCUMENT_TYPE = {
  INVOICE: "invoice",
  PROFORMA: "proforma",
  DRAFT: "draft",
} as const;
export type BillingoDocumentType = (typeof BILLINGO_DOCUMENT_TYPE)[keyof typeof BILLINGO_DOCUMENT_TYPE];

// --- Payment Methods ---
export const BILLINGO_PAYMENT_METHOD = {
  WIRE_TRANSFER: "wire_transfer",
  CASH: "cash",
  BANKCARD: "bankcard",
  // Add other valid methods from Billingo docs/UI
} as const;
export type BillingoPaymentMethod = (typeof BILLINGO_PAYMENT_METHOD)[keyof typeof BILLINGO_PAYMENT_METHOD];

// --- Document Languages ---
export const BILLINGO_LANGUAGE = {
  HU: "hu",
  EN: "en",
  DE: "de",
  // Add other valid languages from Billingo docs/UI
} as const;
export type BillingoLanguage = (typeof BILLINGO_LANGUAGE)[keyof typeof BILLINGO_LANGUAGE];

// --- Currencies ---
export const BILLINGO_CURRENCY = {
  HUF: "HUF",
  EUR: "EUR",
  USD: "USD",
  // Add others based on docs/UI
} as const;
export type BillingoCurrency = (typeof BILLINGO_CURRENCY)[keyof typeof BILLINGO_CURRENCY];

// --- VAT Rates ---
export const BILLINGO_VAT = {
  AAM: "AAM",
  VAT_27: "27%",
  VAT_0: "0%",
  // Add other valid VAT codes from Billingo docs/UI
} as const;
export type BillingoVat = (typeof BILLINGO_VAT)[keyof typeof BILLINGO_VAT];

// --- Unit Price Types ---
export const BILLINGO_UNIT_PRICE_TYPE = {
  NET: "net",
  GROSS: "gross",
} as const;
export type BillingoUnitPriceType = (typeof BILLINGO_UNIT_PRICE_TYPE)[keyof typeof BILLINGO_UNIT_PRICE_TYPE];

// --- Partner Tax Types ---
export const BILLINGO_PARTNER_TAX_TYPE = {
  NO_TAX_NUMBER: "NO_TAX_NUMBER",
  FOREIGN: "FOREIGN",
  HAS_TAX_NUMBER: "HAS_TAX_NUMBER",
  EMPTY: "",
  // Add others based on docs/UI
} as const;
export type BillingoPartnerTaxType = (typeof BILLINGO_PARTNER_TAX_TYPE)[keyof typeof BILLINGO_PARTNER_TAX_TYPE];

// --- Document Block Types ---
export const BILLINGO_DOCUMENT_BLOCK_TYPE = {
  INVOICE: "invoice",
  DRAFT: "draft",
  PROFORMA: "proforma",
  RECEIPT: "receipt",
  MODIFICATION: "modification",
  CANCELLATION: "cancellation",
  ADVANCE: "advance",
} as const;
export type BillingoDocumentBlockTypeConst = (typeof BILLINGO_DOCUMENT_BLOCK_TYPE)[keyof typeof BILLINGO_DOCUMENT_BLOCK_TYPE];

// --- Rounding ---
export const BILLINGO_ROUND = {
  NONE: "none",
  FIVE: "five",
  TEN: "ten",
} as const;
export type BillingoRound = (typeof BILLINGO_ROUND)[keyof typeof BILLINGO_ROUND];

// --- Default Values ---
export const DEFAULT_BILLINGO_COUNTRY_CODE = "HU";
export const DEFAULT_BILLINGO_DUE_DAYS = 14;
export const DEFAULT_BILLINGO_ITEM_UNIT = "alkalom";

// --- Add other constant sets as needed ---

